import { Injectable, Injector } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { IStudentAssessment } from '../../../shared/typings/interfaces/student-assessment.interface';
import * as studentAssessmentsActions from '../../actions/assessments-actions/student-assessments-actions';
import { ApiService } from './../../../shared/services/api-service/api-service';
import { BackgroundJob } from './../../../shared/services/background-job/background-job.service';

@Injectable()
export class StudentAssessmentsEffects {
  constructor(
    private actions$: Actions,
    private apiService: ApiService,
    private backgroundJob: BackgroundJob,
    private injector: Injector,
  ) {}

  @Effect()
  loadStudentAssessments$ = this.actions$.pipe(
    ofType(studentAssessmentsActions.LOAD_STUDENT_ASSESSMENTS),
    switchMap((action: { type: string; payload: any }) => {
      const { schoolId, schoolYear } = action.payload;
      // This filter could also be moved to the route, but it seems unlikely there will be
      // need to show discharged students studentAssessment records anywhere in the portal at this time
      // so keeping the filter here for now.
      const where = '{\\"status\\": {\\"$ne\\": \\"DELETED\\"}}';
      return this.apiService.getStudentAssessments({ schoolId, schoolYear, where }).pipe(
        switchMap((response: { data: { StudentAssessments: IStudentAssessment[] } }) => {
          return [new studentAssessmentsActions.LoadStudentAssessmentsSuccess(response)];
        }),
        catchError(error => of(new studentAssessmentsActions.LoadStudentAssessmentsFail(error))),
      );
    }),
  );

  /* istanbul ignore next */
  @Effect({ dispatch: false })
  updateStudentAssessments$ = this.actions$.pipe(
    ofType(studentAssessmentsActions.BULK_UPDATE_STUDENT_ASSESSMENTS),
    switchMap((action: { type: string; payload: studentAssessmentsActions.IBulkUpdateStudentAssessmentsPayload }) => {
      const backgroundJobSpinner = this.injector.get('BackgroundJobSpinner');
      return this.apiService.patchStudentAssessments(action.payload).pipe(
        switchMap((response: { data: { bulkUpdateStudentAssessment: { backgroundJobId: string } } }) => {
          const {
            data: {
              bulkUpdateStudentAssessment: { backgroundJobId },
            },
          } = response;
          const promise = (this.backgroundJob as any)(backgroundJobId).promise();
          backgroundJobSpinner.activateSpinner('Updating assessments...', promise, null);
          return of(promise);
        }),
        catchError(error => {
          return of(new studentAssessmentsActions.BulkUpdateStudentAssessmentsFail(error));
        }),
      );
    }),
  );
}
